"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formReducer = exports.initialState = void 0;
exports.initialState = {
    firstName: { value: "", touched: false, required: true },
    lastName: { value: "", touched: false, required: true },
    email: { value: "", touched: false, required: true },
    streetAddress: { value: "", touched: false, required: false },
    city: { value: "", touched: false, required: false },
    province: { value: "", touched: false, required: false },
    linkedInUrl: { value: "", touched: false, required: false },
    cvUpload: { value: null, touched: false, required: true },
    about: { value: "", touched: false, required: false },
    errors: {},
};
var formReducer = function (state, action) {
    var _a;
    var _b = action.field, field = _b === void 0 ? "" : _b, _c = action.value, value = _c === void 0 ? "" : _c, _d = action.errors, errors = _d === void 0 ? {} : _d, _e = action.fields, fields = _e === void 0 ? {} : _e;
    var currentValues = field ? state[field] : {};
    switch (action.type) {
        case "SET_FIELD":
            return __assign(__assign({}, state), (_a = {}, _a[field] = __assign(__assign({}, currentValues), { value: value, touched: true }), _a));
        case "SET_ERROR":
            return __assign(__assign({}, state), { errors: __assign({}, errors) });
        case "CLEAR_ERRORS":
            return __assign(__assign({}, state), { errors: {} });
        case "SET_MULTIPLE_FIELDS":
            var updatedFields = Object.keys(fields).reduce(function (acc, key) {
                var _a;
                var _b, _c;
                var fieldKey = key;
                return __assign(__assign({}, acc), (_a = {}, _a[fieldKey] = __assign(__assign({}, state[fieldKey]), { value: (_c = (_b = fields[fieldKey]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : state[fieldKey].value, touched: false }), _a));
            }, {});
            return __assign(__assign({}, state), updatedFields);
        default:
            return state;
    }
};
exports.formReducer = formReducer;
